import YoutubeBreadCrumbSchema from '@seo/schemas/youtubeBreadCrumbSchema';
import { thumbnailMapping } from './constants';

const getFreeClassPlayListBreadcrumbs = (goal, slug, playlistUID) => {
  if (!goal) return [];
  return [
    {
      title: goal?.name,
      url: `/goal/${goal?.slug}/${goal?.uid}`
    },
    {
      title: 'Free classes',
      url: `/goal/${goal?.slug}/${goal?.uid}/classes`
    },
    {
      title: 'Popular classes',
      url: `/curated-classes/${slug}/${playlistUID}`
    }
  ];
};

export default getFreeClassPlayListBreadcrumbs;

export const getAuthorName = (author) => {
  if (!author) return '';
  return `${author?.firstName} ${author?.lastName}`;
};

export const appInstallInfoData = {
  title: 'Download learner’s app to start your preparation',
  description: 'Over 8,00,000 learners trust us for their preparation',
  benefits: [
    'Fully organized study planner',
    'Exceptional educators to learn from',
    'Mock tests, live quizzes & practice'
  ],
  label: 'Download the app'
};

const ENGLISH = 1;
const HINDI = 2;
const PUNJABI = 3;
const KANNADA = 4;
const SPANISH = 5;
const FRENCH = 6;
const TAMIL = 7;
const TELUGU = 8;
const MALAYALAM = 9;
const MARATHI = 10;
const BENGALI = 11;
const GUJRATI = 12;
const MAITHILI = 13;
const ORIYA = 14;
const GERMAN = 51;
const PORTUGUESE = 52;
const INDONESIAN = 53;
const BHOJPURI = 54;
const ASSAMESE = 55;
const URDU = 56;
const MEWARI = 57;
const SANSKRIT = 58;
const HINGLISH = 59;

export const LANGUAGE_MAP = {
  [ENGLISH]: {
    languageText: 'En'
  },
  [HINDI]: {
    languageText: 'हि'
  },
  [PUNJABI]: {
    languageText: 'ਪ'
  },
  [KANNADA]: {
    languageText: 'ಕ'
  },
  [SPANISH]: {
    languageText: 'es'
  },
  [FRENCH]: {
    languageText: 'Fr'
  },
  [TAMIL]: {
    languageText: 'த'
  },
  [TELUGU]: {
    languageText: 'తె'
  },
  [MALAYALAM]: {
    languageText: 'മ'
  },
  [MARATHI]: {
    languageText: 'म'
  },
  [BENGALI]: {
    languageText: 'ব'
  },
  [GUJRATI]: {
    languageText: 'ગુ'
  },
  [MAITHILI]: {
    languageText: 'मै'
  },
  [ORIYA]: {
    languageText: 'ଓ'
  },
  [GERMAN]: {
    languageText: 'de'
  },
  [PORTUGUESE]: {
    languageText: 'P'
  },
  [INDONESIAN]: {
    languageText: 'h'
  },
  [BHOJPURI]: {
    languageText: 'भो'
  },
  [ASSAMESE]: {
    languageText: 'অ'
  },
  [URDU]: {
    languageText: 'اردو'
  },
  [MEWARI]: {
    languageText: 'मे'
  },
  [SANSKRIT]: {
    languageText: 'सं'
  },
  [HINGLISH]: {
    languageText: 'हिn'
  }
};

export const convertTitleToSlug = (title = '') => {
  return title
    .trim() // remove whitespaces at the start and end of string
    .toLowerCase()
    .replace(/^-+/g, '') // remove one or more dash at the start of the string
    .replace(/[^\w-]+/g, '-') // convert any on-alphanumeric character to a dash
    .replace(/-+/g, '-') // convert consecutive dashes to singuar one
    .replace(/-+$/g, ''); // remove one or more dash at the end of the string
};

export const getCuratedClassesSchema = ({
  goalInfo,
  playlistUID,
  slug,
  lessonDetailsInfo,
  playlistDetails
}) => {
  const graph = [];

  const curatedClassesSchema = {
    '@context': 'http://schema.org',
    '@type': 'ItemList',
    numberOfItems: lessonDetailsInfo?.lessonsCount,
    itemListElement: playlistDetails?.results?.map((classData, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: classData.name,
      url: classData?.nextSession?.properties?.permalink
    }))
  };

  graph.push(curatedClassesSchema);

  const breadCrumbs = getFreeClassPlayListBreadcrumbs(
    goalInfo,
    slug,
    playlistUID
  );
  graph.push(YoutubeBreadCrumbSchema(breadCrumbs));
  const schema = {
    '@context': 'https://schema.org/',
    '@graph': graph
  };
  return schema;
};

export const getPlaylistThumbnail = (topicName) => {
  const alphabet = (topicName?.charAt(0) || '').toLowerCase();
  return thumbnailMapping[alphabet] || thumbnailMapping.a;
};
